<template>
  <v-container fluid class="pa-8">
    <v-row>
      <v-col cols="12">
        <home-current-page></home-current-page>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <h2 class="title-page">Conservação</h2>
        <h4 class="mt-2 subtitle-page">
          Use o campo de busca para selecionar uma bacia e visualizar dados de
          meio ambiente.
        </h4>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <map-search-form
          class="elevation-0"
          @result="searchResult = $event"
          @resultLocation="resultLocation($event)"
          :idClick="idClick"
          from="conservation"
          category="Manancial"
        >
        </map-search-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <conservation-map
          :searchResult="searchResult"
          :location="location"
          from="conservation"
          @idClick="idClick = $event"
        >
        </conservation-map>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card color="primary darken-1">
          <div v-if="showAnimation" style="height: 300px">
            <loading-animation
              @loopComplete="loadAnimationComplete"
            ></loading-animation>
          </div>
        </v-card>
        <last-recorded-data
          v-show="!showAnimation && location"
          :location="location"
          :basinIcon="basinIcon"
          :fireRisk="fireRisk"
          :hotSpots="hotSpots"
        ></last-recorded-data>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card color="primary darken-1">
          <div v-if="showAnimation" style="height: 300px">
            <loading-animation
              @loopComplete="loadAnimationComplete"
            ></loading-animation>
          </div>
        </v-card>
        <land-use-and-cover-mobile
          v-if="this.$vuetify.breakpoint.name === 'xs'"
          v-show="!showAnimation && location"
          :forest="forest"
          :farming="farming"
          :naturalFormation="naturalFormation"
          :notVegetated="notVegetated"
          :notObserved="notObserved"
          :waterBodies="waterBodies"
          :years="years"
          :chart="chart"
        />
        <land-use-and-cover
          v-else
          v-show="!showAnimation && location"
          :forest="forest"
          :farming="farming"
          :naturalFormation="naturalFormation"
          :notVegetated="notVegetated"
          :notObserved="notObserved"
          :waterBodies="waterBodies"
          :years="years"
          :chart="chart"
        ></land-use-and-cover>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card color="primary darken-1">
          <div v-if="showAnimation" style="height: 300px">
            <loading-animation
              @loopComplete="loadAnimationComplete"
            ></loading-animation>
          </div>
        </v-card>
        <historical-data-conservation
          v-show="!showAnimation"
          :location="location"
          :basinIcon="basinIcon"
          :percentageSeries="percentageSeries"
          :hectareSeries="hectareSeries"
          :text="text"
          :years="years"
        ></historical-data-conservation>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card color="primary darken-1">
          <div v-if="showAnimation" style="height: 300px">
            <loading-animation
              @loopComplete="loadAnimationComplete"
            ></loading-animation>
          </div>
        </v-card>
        <evolution-land-use-and-land-cover-charts
          v-show="!showAnimation && location"
          :location="location"
          :basinIcon="basinIcon"
          :percentageSeries="seriesPercentageEvolution"
          :hectareSeries="seriesHectareEvolution"
          :text="text"
          :years="years"
        ></evolution-land-use-and-land-cover-charts>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <deforestation-charts
        v-show="!showAnimation && location"
        ></deforestation-charts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HomeCurrentPage from '@/components/common/HomeCurrentPage.vue';
import MapSearchForm from '@/components/common/MapSearchForm.vue';
import ConservationMap from '@/components/Conservation/ConservationMap.vue';
import LastRecordedData from '@/components/Conservation/LastRecordedData';
import LoadingAnimation from '@/components/common/LoadingAnimation';
import LandUseAndCover from '@/components/Conservation/LandUseAndCover';
import HistoricalDataConservation from '@/components/Conservation/HistoricalDataConservation';
import moment from 'moment';
import EvolutionLandUseAndLandCoverCharts from '@/components/Conservation/EvolutionLandUseAndLandCoverCharts';
import LandUseAndCoverMobile from '@/components/Conservation/LandUseAndCoverMobile';
import DeforestationCharts from '@/components/Conservation/DeforestationCharts.vue';

export default {
  name: 'Conservation',
  components: {
    LandUseAndCoverMobile,
    EvolutionLandUseAndLandCoverCharts,
    HistoricalDataConservation,
    LandUseAndCover,
    LoadingAnimation,
    LastRecordedData,
    ConservationMap,
    MapSearchForm,
    HomeCurrentPage,
    DeforestationCharts
  },
  data() {
    return {
      searchResult: undefined,
      class: '',
      interval: {},
      location: undefined,
      loading: false,
      showAnimation: false,
      idClick: undefined,
      basinIcon: {
        name: 'icon-infohidro-bacia',
        color: '#69D7A3',
      },
      forest: {last: 0, previous: 0},
      farming: {last: 0, previous: 0},
      naturalFormation: {last: 0, previous: 0},
      notVegetated: {last: 0, previous: 0},
      notObserved: {last: 0, previous: 0},
      waterBodies: {last: 0, previous: 0},
      years: undefined,
      chart: [],
      percentageSeries: [],
      hectareSeries: [],
      text: '',
      seriesHectareEvolution: [],
      seriesPercentageEvolution: [],
      fireRisk: undefined,
      hotSpots: undefined,
      isProduction: process.env.NODE_ENV === 'production' ? true : false,
    };
  },
  computed: {
    classes() {
      return this.$store.getters.classes;
    },
    locacronymn() {
      return this.$store.getters.locacronymn;
    },
    sia() {
      return this.$store.getters.sia;
    },
    evolution() {
      return this.$store.getters.evolution;
    },
  },
  methods: {
    dateToUTC(x) {
      x = moment(x, 'YYYY').locale('en').format('YYYY');
      x = moment.utc(x).locale('en').valueOf();
      return x;
    },
    async resultLocation(location) {
      this.location = location;
      if (this.location) {
        await this.initializeData();
      }
    },
    loadAnimationComplete() {
      this.showAnimation = this.loading;
    },
    async initializeData() {
      this.loading = true;
      this.showAnimation = true;

      this.forest = {last: 0, previous: 0};
      this.farming = {last: 0, previous: 0};
      this.naturalFormation = {last: 0, previous: 0};
      this.notVegetated = {last: 0, previous: 0};
      this.notObserved = {last: 0, previous: 0};
      this.waterBodies = {last: 0, previous: 0};
      this.chart = [];
      this.seriesHectareEvolution = [];
      this.seriesPercentageEvolution = [];
      this.years = undefined;
      await this.$store.dispatch('loadClasses');

      await this.$store.dispatch('loadLocacronymn', {
        location_id: this.location.locationid,
        basin_id: 16,
      });
      await this.$store.dispatch('loadHotSpots', {
        location_id: this.location.locationid,
      });
      await this.$store.dispatch('loadSaneparLocations', {
        locationIds: [this.location.locationid],
        ref: "SIA",
      });
      const saneparLocation = await this.$store.getters.saneparLocations;

      let copy = await this.locacronymn;
      this.text = copy.locacronymn;

      await this.$store.dispatch('loadSia', {
        locacronymn: saneparLocation[0]?.acronym
      });
      await this.$store.dispatch('loadSiaEvolution', {
        locacronymn: saneparLocation[0]?.acronym,
      });
      await this.$store.dispatch('loadLandUseOverview', {
        locacronymn: saneparLocation[0]?.acronym,
      });

      copy = await this.sia[0]; // sia + values per year of land use
      let evolution = await this.evolution;
      let landUseOverview = await this.$store.getters.landUseOverview;

      //
      let holder = await this.$store.getters.hotSpots;
      this.hotSpots = {
        amount: 'Nenhum',
        updated: moment()
          .tz('America/Sao_Paulo')
          .format('YYYY-MM-DD HH:mm:ssZ'),
      };
      if (holder[0]) {
        this.hotSpots = holder[0];
      }

      await this.$store.dispatch('loadFmac');
      let fireRisks = await this.$store.getters.fireRisk;
      let fireRisk = {};
      fireRisk.date = fireRisks?.['date'];
      fireRisk.risk = fireRisks?.['FMAc']?.[this.text];
      fireRisk.date = moment(fireRisk.date, 'YYYYMMDD')
        .tz('America/Sao_Paulo')
        .format('DD/MM/YYYY');
      this.fireRisk = fireRisk;

      //
      let years = [];
      let newList = [];
      let series = [];
      let obj = await copy?.values;
      for (let year in obj) {
        years.push(year);
        newList.push(obj[year]);
        for (let id in obj[year]) {
          let inside;
          let holder = {id: Number(id)};
          if (series.length >= 0) {
            inside = series.find((item) => item.id === Number(id));
          }
          if (!inside) {
            series.push(holder);
          }
        }
      }
      this.years = years;
      let last = newList.length - 1;
      let previous = newList.length - 2;
      if (newList) {
        last = await newList[last];
        previous = await newList[previous];
      }
      if (last && previous) {
        for (let key1 in last) {
          for (let key2 in previous) {
            if (key1 === key2) {
              if (
                Number(key1) === 3 ||
                Number(key1) === 4 ||
                Number(key1) === 5 ||
                Number(key1) === 49
              ) {
                //Floresta
                this.forest.last = this.forest.last + last[key1];
                this.forest.previous = this.forest.previous + previous[key2];
              } else if (
                Number(key1) === 15 ||
                Number(key1) === 18 ||
                Number(key1) === 19 ||
                Number(key1) === 39 ||
                Number(key1) === 20 ||
                Number(key1) === 40 ||
                Number(key1) === 41 ||
                Number(key1) === 36 ||
                Number(key1) === 46 ||
                Number(key1) === 47 ||
                Number(key1) === 48 ||
                Number(key1) === 9 ||
                Number(key1) === 21
              ) {
                //Agropecuária
                this.farming.last = this.farming.last + last[key1];
                this.farming.previous = this.farming.previous + previous[key2];
              } else if (
                Number(key1) === 11 ||
                Number(key1) === 12 ||
                Number(key1) === 32 ||
                Number(key1) === 29 ||
                Number(key1) === 13
              ) {
                //Formação natural
                this.naturalFormation.last =
                  this.naturalFormation.last + last[key1];
                this.naturalFormation.previous =
                  this.naturalFormation.previous + previous[key2];
              } else if (
                Number(key1) === 23 ||
                Number(key1) === 24 ||
                Number(key1) === 30 ||
                Number(key1) === 25
              ) {
                //Não vegetada
                this.notVegetated.last = this.notVegetated.last + last[key1];
                this.notVegetated.previous =
                  this.notVegetated.previous + previous[key2];
              } else if (Number(key1) === 33 || Number(key1) === 31) {
                //Corpos d'água
                this.waterBodies.last = this.waterBodies.last + last[key1];
                this.waterBodies.previous =
                  this.waterBodies.previous + previous[key2];
              } else if (Number(key1) === 27) {
                //Não observado
                this.notObserved.last = this.notObserved.last + last[key1];
                this.notObserved.previous =
                  this.notObserved.previous + previous[key2];
              }
            }
          }
        }
      }

      //f
      this.notObserved.last = (this.notObserved.last * 30 * 30) / 10000;
      this.waterBodies.last = (this.waterBodies.last * 30 * 30) / 10000;
      this.notVegetated.last = (this.notVegetated.last * 30 * 30) / 10000;
      this.naturalFormation.last =
        (this.naturalFormation.last * 30 * 30) / 10000;
      this.farming.last = (this.farming.last * 30 * 30) / 10000;
      this.forest.last = (this.forest.last * 30 * 30) / 10000;

      //
      this.notObserved.previous = (this.notObserved.previous * 30 * 30) / 10000;
      this.waterBodies.previous = (this.waterBodies.previous * 30 * 30) / 10000;
      this.notVegetated.previous =
        (this.notVegetated.previous * 30 * 30) / 10000;
      this.naturalFormation.previous =
        (this.naturalFormation.previous * 30 * 30) / 10000;
      this.farming.previous = (this.farming.previous * 30 * 30) / 10000;
      this.forest.previous = (this.forest.previous * 30 * 30) / 10000;

      //
      let chart = [
        {id: '0.0', name: '', parent: ''},
        //classes
        {
          id: '1.0',
          name: 'Cobertura Florestal',
          parent: '0.0',
          color: '#459008',
          idSia: '1.0',
        },
        {
          id: '2.0',
          name: 'Formação Natural não Florestal',
          parent: '0.0',
          color: '#5CDF95',
          idSia: '10.0',
        },
        {
          id: '3.0',
          name: 'Agropecuária',
          parent: '0.0',
          color: '#DBAD40',
          idSia: '14.0',
        },
        {
          id: '4.0',
          name: 'Área não Vegetada',
          parent: '0.0',
          color: '#EA9999',
          idSia: '22.0',
        },
        {
          id: '5.0',
          name: "Corpo D'água",
          parent: '0.0',
          color: '#4F7EDB',
          idSia: '26.0',
        },
        {
          id: '6.0',
          name: 'Não Observado',
          parent: '0.0',
          color: '#D5D5E5',
          idSia: '27.0',
        },
        //1. Floresta
        {
          id: '1.1',
          name: 'Formação Florestal',
          parent: '1.0',
          color: '#18812a',
          idSia: '3.0',
        },
        {
          id: '1.2',
          name: 'Formação Savânica',
          parent: '1.0',
          color: '#53a313',
          idSia: '4.0',
        },
        {
          id: '1.3',
          name: 'Mangue',
          parent: '1.0',
          color: '#c46a40',
          idSia: '5.0',
        },
        {
          id: '1.4',
          name: 'Restinga Arborizada',
          parent: '1.0',
          color: '#91aa34',
          idSia: '49.0',
        },
        //2. Formação Natural não Florestal
        {
          id: '2.1',
          name: 'Campo Alagado e Área Pantanosa',
          parent: '2.0',
          color: '#4AC780',
          idSia: '11.0',
        },
        {
          id: '2.2',
          name: 'Formação Campestre',
          parent: '2.0',
          color: '#45B074',
          idSia: '12.0',
        },
        {
          id: '2.3',
          name: 'Apicum',
          parent: '2.0',
          color: '#3E9355',
          idSia: '32.0',
        },
        {
          id: '2.4',
          name: 'Afloramento Rochoso',
          parent: '2.0',
          color: '#aebbb1',
          idSia: '29.0',
        },
        {
          id: '2.5',
          name: 'Outras Formações não Florestais',
          parent: '2.0',
          color: '#f1c232',
          idSia: '13.0',
        },
        //3. Agropecuária
        {
          id: '3.1',
          name: 'Pastagem',
          parent: '3.0',
          color: '#EFAF4E',
          idSia: '15.0',
        },
        {
          id: '3.3',
          name: 'Silvicultura',
          parent: '3.0',
          color: '#d5622c',
          idSia: '9.0',
        },
        {
          id: '3.4',
          name: 'Mosaico de Agricultura e Pastagem',
          parent: '3.0',
          color: '#ffd1be',
          idSia: '21.0',
        },
        {
          id: '3.2',
          name: 'Agricultura',
          parent: '3.0',
          color: '#E57142',
          idSia: '18.0',
        },
        //3.2.1. Lavoura Temporária
        {
          id: '3.2.1',
          name: 'Lavoura Temporária',
          parent: '3.2',
          color: '#E25249',
          idSia: '19.0',
        },
        // 4
        {
          id: '3.2.1.1',
          name: 'Soja',
          parent: '3.2.1',
          color: '#c59ff4',
          idSia: '39.0',
        },
        {
          id: '3.2.1.2',
          name: 'Cana',
          parent: '3.2.1',
          color: '#C27BA0',
          idSia: '20.0',
        },
        {
          id: '3.2.1.3',
          name: 'Arroz',
          parent: '3.2.1',
          color: '#982c9e',
          idSia: '40.0',
        },
        {
          id: '3.2.1.4',
          name: 'Outras Lavouras Temporárias',
          parent: '3.2.1',
          color: '#e787f8',
          idSia: '41.0',
        },
        //3.2.2. Lavoura Perene
        {
          id: '3.2.2',
          name: 'Lavoura Perene',
          parent: '3.2',
          color: '#f3b4f1',
          idSia: '36.0',
        },
        // 3
        {
          id: '3.2.2.1',
          name: 'Café',
          parent: '3.2.2',
          color: '#cca0d4',
          idSia: '46.0',
        },
        {
          id: '.2.2.2',
          name: 'Citrus',
          parent: '3.2.2',
          color: '#d082de',
          idSia: '47.0',
        },
        {
          id: '3.2.2.3',
          name: 'Outras Lavouras Perenes',
          parent: '3.2.2',
          color: '#cd49e4',
          idSia: '48.0',
        },
        //4. Área não Vegetada
        {
          id: '4.1',
          name: 'Praia, Duna e Areal',
          parent: '4.0',
          color: '#fbe051',
          idSia: '23.0',
        },
        {
          id: '4.2',
          name: 'Área Urbanizada',
          parent: '4.0',
          color: '#aa0000',
          idSia: '24.0',
        },
        {
          id: '4.3',
          name: 'Mineração',
          parent: '4.0',
          color: '#f34a4a',
          idSia: '30.0',
        },
        {
          id: '4.4',
          name: 'Outras Áreas não Vegetadas',
          parent: '4.0',
          color: '#E58088',
          idSia: '25.0',
        },
        //5. Corpo D'água
        {
          id: '5.1',
          name: 'Rio, Lago e Oceano',
          parent: '5.0',
          color: '#4F7EDB',
          idSia: '33.0',
        },
        {
          id: '5.2',
          name: 'Aquicultura',
          parent: '5.0',
          color: '#2d54a0',
          idSia: '31.0',
        },
        //6. Não Observado
      ];
      for (let item in landUseOverview) {
        let aux = chart.find((a) => a.idSia === landUseOverview[item].id);
        if (aux) {
          landUseOverview[item].color = aux.color;
          landUseOverview[item].name = aux.name;
        }
      }
      this.chart = landUseOverview;

      series.sort(function (a, b) {
        return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
      });
      for (let item in series) {
        let aux = chart.find((c) => series[item].id === Number(c.idSia));
        if (aux) {
          series[item].name = aux.name;
          series[item].color = aux.color;
          series[item].data = [];
          series[item].marker = {enabled: false, radius: undefined};
        }
      }
      for (let year in obj) {
        for (let item in series) {
          let keys = Object.keys(obj[year]);
          for (let n in keys) {
            keys[n] = parseInt(keys[n]);
          }
          if (!keys.includes(series[item].id)) {
            let id = series[item].id;
            id = id.toFixed(1);
            obj[year][id] = null;
          }
        }
      }
      for (let year in obj) {
        for (let id in obj[year]) {
          let serie = series.find((item) => item.id === Number(id));
          if (serie) {
            let arrayItem = [];
            let x = this.dateToUTC(year);
            let y =
              obj[year][id] === null ? null : (obj[year][id] * 30 * 30) / 10000;
            //let y = obj[year][id]
            arrayItem.push(x);
            arrayItem.push(y);
            serie.data.push(arrayItem);
          }
        }
      }
      this.percentageSeries = series;
      this.hectareSeries = series;

      let reduced = evolution.reduce((objetoFinal, objetoAtual) => {
        if (!objetoFinal[objetoAtual.classid])
          objetoFinal[objetoAtual.classid] = [];
        objetoFinal[objetoAtual.classid].push(objetoAtual);
        return objetoFinal;
      }, {});
      for (let index in reduced) {
        reduced[index] = this.checkHoles(reduced[index], years);
      }
      for (let index in reduced) {
        let item = chart.find((a) => a.idSia === reduced[index][0].classid);
        if (typeof item !== 'undefined') {
          let serieH = {
            name: item.name ? item.name : '',
            color: item.color,
            data: [],
            dashStyle: 'Solid',
            lineWidth: 3,
            marker: {enabled: false, radius: undefined},
          };
          let serieP = {
            name: item.name ? item.name : '',
            color: item.color,
            data: [],
            dashStyle: 'Solid',
            lineWidth: 3,
            marker: {enabled: false, radius: undefined},
          };
          for (let item in reduced[index]) {
            serieH.data.push(reduced[index][item].hectare);
            serieP.data.push(reduced[index][item].percent);
          }
          this.seriesHectareEvolution.push(serieH);
          this.seriesPercentageEvolution.push(serieP);
        }
      }
      this.loading = false;
    },
    checkHoles(copy, dates) {
      let aux = [];
      const pattern = copy[0];
      for (let index in dates) {
        let item = '';
        item = copy.find((a) => a.year === Number(dates[index]));
        if (item) {
          aux.push(item);
        } else {
          let holder = {
            classid: pattern.classid,
            year: dates[index],
            hectare: null,
            pixels: null,
            percent: null,
          };
          aux.push(holder);
        }
      }
      return [...aux];
    },
  },
};
</script>
<style scoped>
.title-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.subtitle-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}
</style>
